
export default {
  name: 'YoutubeChannelId',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "How can I get a custom URL for my YouTube Channel ID?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "To do this, you must have at least 100 subscribers, an account at least 30 days old, and a profile picture. Then, you can customize your URL through the 'About' section in your Channel Settings."
          }
        },
        {
          "@type": "Question",
          "name": "Is it safe to share a YouTube Channel ID?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The answer is yes. It is a unique identifier for your channel and does not reveal sensitive information. Yet, be cautious when sharing personal information or credentials associated with your YouTube account."
          }
        },
        {
          "@type": "Question",
          "name": "Can I use someone else's YouTube Channel ID?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "No. Each channel has its unique ID, and it is specific to that channel owner. Using another's ID would not grant access to their channel or account."
          }
        },
        {
          "@type": "Question",
          "name": "Can I change my Channel YouTube ID?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "No. Once it is assigned to your channel, it remains the same. Yet, you can change the channel name or URL associated with your Channel ID."
          }
        },
        {
          "@type": "Question",
          "name": "Does YouTube verify ID?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "YouTube does not verify the channel ID itself. Yet, it does this process for certain features like verification badges or monetization eligibility."
          }
        }
      ]
    };
  },
  data () {
    return {
      data: '',
      form: this.$vform({
        url: null
      })
    }
  },
  methods: {
    YoutubeChannelId() {
        this.form.post(`/tool/youtube-channel-id`, { progress: false }).then(res => {
          this.data = res.data;
        }).catch(e => {
          console.log(e);
        });
    },
    onSample(){
        this.form.url = 'https://www.youtube.com/@GoogleDevelopers';
    },
    onReset(){
        this.form.reset();
        this.data = null;
    }
  }
}
